import React from "react";
import { STATUS_STYLES } from "../lib/api";

export default function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || "bg-gray-100 text-gray-800 border-gray-300";
  return (
    <span
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-semibold border rounded-sm ${style} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
